module.exports = __webpack_public_path__ + "static/media/rogue1.a935ce00.jpg";